<div class="vtr-ui-header-subpage container-fluid"
	#pageHeadingRef>
	<div class="row"
		*ngIf="title!=undefined">
		<div class="col">
			<span class="title"
				id="{{textId}}-header-title">
				<h2 id="{{textId}}-title">{{title}}</h2>
			</span>
		</div>
	</div>
	<div class="row"
		[ngClass]="{'no-title': title==undefined}"
		*ngIf="caption || menu">
		<div class="col left-border header-subpage-content">
			<div class="col px-20">
				<div class="row">
					<div class="col">
						<p class="caption"
							role="text"
							id="{{textId}}-header-caption"
							style="outline: none;">
							{{caption}}
						</p>
					</div>
				</div>
				<ng-container *ngIf="menu && menu.items && menu.title">
					<div class="row"
						*ngIf="menu.items?.length>1 && menu.title">
						<div class="col">
							<h5 class="menu-title"
								id="{{textId}}-jumptToSettings-title">
								{{menu.title}}:
							</h5>
						</div>
					</div>
					<div class="row"
						*ngIf="menu.items?.length>1">
						<div *ngFor="let item of menu.items; let i=index;"
							class="col-auto p-0">
							<div class="hyperlink-button"
								role="link"
								tabindex="0"
								id="jumptoSetting-{{item.path}}"
								(click)="menuItemClick($event, item)"
								(keydown.enter)="menuItemClick($event, item)">
								{{item.title | translate}}
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
